export namespace DelegationActions {
  export class LoadActiveDelegationDetails {
    static readonly type = '[Delegation] Load Active Delegation Details';
  }

  export class FetchAvailableDelegations {
    static readonly type = '[Delegation] Load Available Delegations';
  }
}
